import { ChangeDetectionStrategy, Component, computed, input, model, output, ViewEncapsulation } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Workflow } from "../service/Workflow";

@Component({
    standalone: true,
    selector: "s25-ng-workflow-action-input",
    template: `
        <label>
            {{ label() }}
            @if (required()) {
                <span class="required">*</span>
            }
        </label>
        @if (help()) {
            <small class="form-text">{{ help() }}</small>
        }
        @if (type() === "textarea") {
            <textarea [(ngModel)]="value" class="form-control" rows="3" [placeholder]="placeholder()"></textarea>
        } @else {
            <input type="text" [(ngModel)]="value" class="form-control" [placeholder]="placeholder()" />
        }
    `,
    styles: `
        :host {
            display: block;
        }

        label {
            display: block;
            margin-bottom: 4px;
            font-weight: 500;
            color: #555;
        }

        .required {
            color: #dc3545;
            font-weight: bold;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ReactiveFormsModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowActionInputComponent {
    value = model.required<string>();
    label = input.required<Workflow.SystemActionInput["label"]>();
    type = input.required<Workflow.SystemActionInput["type"]>();
    required = input.required<Workflow.SystemActionInput["required"]>();
    help = input.required<Workflow.SystemActionInput["help"]>();

    placeholder = computed(() => "Enter " + this.label().toLowerCase());
}
